<p>view-lead-quotations-confirm works!</p>
